import { ValidationSchema } from "_core/form";
import {
  AndersenCableLength,
  AndersenA2A3Colours,
  AndersenQuartzColours,
} from "_core/types/charger";
import { CableSetup, ErrorMessages } from "_core/types";

export type QuartzFormValues = {
  cableSetup: CableSetup;
  cableLength: AndersenCableLength;
  baseColour: AndersenQuartzColours;
};

export type A2A3FormValues = {
  baseColour: AndersenA2A3Colours;
};

export const AndersenQuartzChargerCustomisation: ValidationSchema<QuartzFormValues> =
  {
    cableSetup: ({ cableSetup }) => {
      if (!cableSetup) return ErrorMessages.SELECT_CABLE_SETUP;
    },
    cableLength: ({ cableSetup, cableLength }) => {
      if (cableSetup === "tethered") {
        if (!cableLength) return ErrorMessages.SELECT_CABLE_LENGTH;
      }
    },
    baseColour: ({ baseColour }) => {
      if (!baseColour) return ErrorMessages.SELECT_CHARGER_COLOUR;
    },
  };

export const AndersenA2A3ChargerCustomisation: ValidationSchema<A2A3FormValues> =
  {
    baseColour: ({ baseColour }) => {
      if (!baseColour) return ErrorMessages.SELECT_CHARGER_COLOUR;
    },
  };
